import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

const FaIcon = ({
    icon,
    size = "sm",
    className = "",
    onClick,
    style = {},
    ariaLabel="",
    tabIndex=0,
    fixedWidth=false,
  }) => {
  // If a color is passed, mirror it to fill/stroke to defeat CSS that sets fill
  const colorPatches =
    style.color
      ? { color: style.color, fill: style.color, stroke: style.color }
      : {};

  const mergedStyle = {
    fontSize: style.fontSize || undefined,
    ...colorPatches,
    ...style
  };

  return (
    <FontAwesomeIcon
      icon={icon}
      size={size}
      className={className}
      onClick={onClick}
      style={mergedStyle}
      aria-label={ariaLabel}
      tabIndex={tabIndex}
      fixedWidth={fixedWidth}
    />
  );
};

FaIcon.propTypes = {
  icon: PropTypes.object.isRequired,
  size: PropTypes.oneOf(["xs", "sm", "lg", "xl", "2xl", "2x", "3x", "4x"]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  ariaLabel: PropTypes.string,
  tabIndex: PropTypes.number,
  fixedWidth: PropTypes.bool,
};

export default FaIcon;